import { useReduxState } from 'hooks';
import { ApiDownloadButton, Button, ConfirmButton } from 'components/common';
import { Icon } from 'components/common/icons';

interface Props {
  file?: { title?: string; url: string };
  onRemove?: () => void;
  onReplace?: () => void;
  type: 'audio' | 'embedlink' | 'file' | 'h5p' | 'scorm' | 'video';
}

const EditorBlockEmbedFileControls = ({
  file,
  onRemove,
  onReplace,
  type
}: Props) => {
  const { messages } = useReduxState();

  const buttonStyle = { marginRight: 5, padding: 5 };

  const iconStyle = {
    marginRight: 0,
    fontSize: '1.8rem',
    verticalAlign: 'text-bottom'
  };

  const downloadTooltip =
    type === 'scorm'
      ? messages.editorBlockEmbedExportScormFile
      : type === 'h5p'
      ? messages.editorBlockEmbedExportH5PFile
      : messages.commonDownloadFile;

  const backupFilename = file?.url?.split('/').pop() || type;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
      {file?.url ? (
        <ApiDownloadButton
          category="light"
          filename={file?.title || backupFilename}
          iconStyle={iconStyle}
          text={<Icon fixedWidth={true} icon="download" />}
          url={file.url}
          external={true}
          style={buttonStyle}
          tooltip={downloadTooltip}
        />
      ) : null}

      {onReplace && (
        <Button
          category="light"
          icon="sync-alt"
          onClick={onReplace}
          size="small"
          style={buttonStyle}
          tooltip={messages.editorBlockImageReplace}
        />
      )}

      {onRemove && (
        <ConfirmButton
          actionText={messages.commonRemove}
          buttonCategory="light"
          buttonIcon="trash-alt"
          buttonSize="small"
          buttonTooltip={messages.commonRemove}
          confirmText={messages.courseLanguageVersionsRemoveFile}
          confirmTitle={messages.uploaderRemoveFile}
          onConfirm={() => {
            onRemove();
            return true;
          }}
        />
      )}
    </div>
  );
};

export default EditorBlockEmbedFileControls;
